
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselGenericStoppedFilled as ObiVesselGenericStoppedFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-generic-stopped-filled.js';
 
 
 

 
 export const ObiVesselGenericStoppedFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-generic-stopped-filled',
   elementClass: ObiVesselGenericStoppedFilledElement,
   events: {
     
   }
  });
 
 